import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1491f838&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=1491f838&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1491f838",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EmptyUser: require('/builds/master/frontend/frontend-universe/components/empty-user.vue').default,Subscription: require('/builds/master/frontend/frontend-universe/components/subscription/subscription.js').default})
